import { Routes, Route, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useAuthStore } from './store/auth-store';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { AdminLayout } from './components/layout/AdminLayout';
import { Login } from './pages/Login';
import { Dashboard } from './pages/Dashboard';
import { BusinessList } from './pages/businesses/BusinessList';
import { BusinessDetail } from './pages/businesses/BusinessDetail';
import { TrainerList } from './pages/trainers/TrainerList';
import { TrainerDetail } from './pages/trainers/TrainerDetail';
import { FacilityList } from './pages/facilities/FacilityList';
import { ProductList } from './pages/products/ProductList';
import { TrainingList } from './pages/trainings/TrainingList';
import { AuditLogList } from './pages/audit/AuditLogList';
import { CategoryList } from './pages/categories/CategoryList';

function App() {
  const { initializeAuth } = useAuthStore();

  useEffect(() => {
    initializeAuth();
  }, [initializeAuth]);

  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<Login />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <Dashboard />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/businesses"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <BusinessList />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/businesses/:id"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <BusinessDetail />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/trainers"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <TrainerList />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/trainers/:id"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <TrainerDetail />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/facilities"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <FacilityList />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/products"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <ProductList />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/trainings"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <TrainingList />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/categories"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <CategoryList />
            </AdminLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/audit-logs"
        element={
          <ProtectedRoute>
            <AdminLayout>
              <AuditLogList />
            </AdminLayout>
          </ProtectedRoute>
        }
      />

      {/* Catch-all redirect */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
